import LedgerSection from "./LedgerSection";
import { getB2BLedger } from "../../services/salesDashboard";

const B2BLedger = () => (
  <LedgerSection title="B2B Ledger" typeLabel="B2B" fetchFn={getB2BLedger} paginated={false} />
);

export default B2BLedger;
